module.exports = __webpack_public_path__ + "img/t_logo_2.e3336a99.png";